import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=25140104&scoped=true"
import script from "./Index.vue.js?vue&type=script&lang=js&external"
export * from "./Index.vue.js?vue&type=script&lang=js&external"
import style0 from "./Index.vue?vue&type=style&index=0&id=25140104&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25140104",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
